// extracted by mini-css-extract-plugin
export default {"gender-category-wrap":"index_gender-category-wrap__Ayht1","mn-category":"index_mn-category__iyLrH"};